<template>
  <ColumnContent :title="t('Клиники', options)">
    <a
      v-for="lpu in lpuList"
      :key="lpu.translit"
      class="d-table text--text link-decoration-none mb-4 text-body-1"
      data-qa="lpu-types-link"
      :href="reverseFullL10N({ name: 'lpu_speciality', args: { type_lpu_translit: lpu.translit, language: urlLang } })"
    >
      {{ transDynamic(lpu, `name,${language},${needTranslate}`) }}
    </a>
  </ColumnContent>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import { useContextStore, useURLStore } from 'src/store'
import { ColumnContent } from 'src/layouts'
import { ContextStore } from 'src/components/pages/lpu/index/types'

// @ts-ignore
const { context, urlLang }: ContextStore = useContextStore()
const { reverseFullL10N } = useURLStore()

const { t, language } = I18NextVue
const options = { ns: language }
const needTranslate = context.feature_flags.pd_l10n_footer_pages

const lpuList = ref(
  [...context.lpu_types_gover, ...context.lpu_types_private].sort((a, b) => a.name.localeCompare(b.name)),
)
</script>
